import { CompanyBase } from '../types/userProps'

export const getCompanyDisplayName = (
  { companyName, locationCode }: CompanyBase = { companyId: 0 },
  prependLocationCode: boolean
): string | undefined =>
  prependLocationCode && locationCode
    ? `${locationCode} - ${companyName}`
    : companyName
